import { parse, stringifyUrl } from "query-string";
import { useHistory as baseUseHistory } from "react-router";
import { Note } from "../components/Note";
import { API } from "./api";
import { baseURL } from "./config";

export function useHistory() {
  const history = baseUseHistory();
  history.query = function (query = null, replace = false) {
    if (query == null) {
      return parse(history.location.search);
    } else {
      history.push({
        search: stringifyUrl(
          {
            url: replace ? "" : history.location.search,
            query,
          },
          {
            skipNull: true,
            skipEmptyString: true,
          }
        ),
      });
    }
  };
  return history;
}

export const getURL = (url) => {
  return `${baseURL}${url}`;
};

export const getSiteName = (value) => {
  try {
    return value.split(".")[0];
  } catch {
    return value;
  }
};

export const addPriceComma = (value) => {
  return value
    .toString()
    .replace(/,/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const removePriceComma = (value) => {
  return value.toString().replace(/,/g, "");
};

export const addTomanPriceComma = (value) => {
  return addPriceComma(~~(value / 10));
};

export const isDigit = (value) => {
  const reg = /^[\d۰۱۲۳۴۵۶۷۸۹]*?$/;
  return !isNaN(value) && reg.test(value);
};

export const checkValidEngNumbers = (e) => {
  if (
    !isDigit(e.key) &&
    e.key !== "Backspace" &&
    e.key !== "ArrowLeft" &&
    e.key !== "ArrowRight"
  ) {
    e.preventDefault();
  }
};

export const getCities = (province_id) => {
  // return API.get.cities(province_id);
};

export const onChangeProvince = (value, onChange, setCities) => {
  if (onChange) {
    onChange();
  }
  getCities(value).then((response) => {
    if (response.success) {
      setCities(response.data);
    } else {
      Note.error(response.message);
    }
  });
};

export const rangeGenerator = (highEnd, lowEnd) => {
  let list = [];
  for (let i = highEnd; i >= lowEnd; i--) {
    list.push(i);
  }
  return list;
};

export const onEnterAlphabet = (text) => {
  return /^[ا-ی]+$/.test(text);
};

export const toEnglishNumber = (number) => {
  const fa = "۰۱۲۳۴۵۶۷۸۹".split("");
  const en = "0123456789".split("");
  let engNumber = "";
  number.split("").forEach((num) => {
    if (fa.includes(num)) {
      engNumber += en[fa.indexOf(num)];
    }
  });
  return engNumber || number;
};

export const showManuFactoringYearsByCarModel = (model, year_range) => {
  const solar = year_range?.solar ? year_range?.solar.split("-") : [];
  const gregorian = year_range?.gregorian
    ? year_range?.gregorian.split("-")
    : [];
  const current_year_range = model?.is_jalali ? solar : gregorian;

  return rangeGenerator(current_year_range[1], current_year_range[0]);
};

export const convertParamsIdToNumber = (value) =>
  value ? Number(value) : null;

export const formatAntdJalaliDate = (date) => {
  return `${date?.$jy || date?.$y}-${(date?.$jM || date.$M) + 1}-${
    date?.$jD || date?.$D
  }`;
};
